
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class FaqDropdown extends Vue {
  @Prop({ type: String, required: true }) title!: string

  private isOpen = false

  private toggle () {
    this.isOpen = !this.isOpen
  }
}
